var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import { Password, SimpleWallet } from "nem-library";
import ToolBar from "../../parts/ToolBar.vue";
import PinDialog from "../../parts/PinDialog.vue";
import { PinCodeHelper, WalletsHelper } from "../../../lib/storage";
export default Vue.extend({
    components: { ToolBar, PinDialog },
    name: "WalletCreationName",
    data() {
        return {
            walletName: "",
            showPinDialog: false,
        };
    },
    methods: {
        prohibited() {
            return this.walletName.length == 0;
        },
        createWallet() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!(yield PinCodeHelper.hasSavedCode())) {
                    yield this.createWalletWithPin(PinCodeHelper.defaultPin);
                }
                else {
                    this.showPinDialog = true;
                }
            });
        },
        createWalletWithPin(pinCode) {
            return __awaiter(this, void 0, void 0, function* () {
                const pass = new Uint8Array(32);
                crypto.getRandomValues(pass);
                const password = new Password(pass.toString());
                const simpleWallet = SimpleWallet.create(this.walletName, password);
                const account = simpleWallet.open(password);
                const wallet = yield WalletsHelper.createWithKeys(simpleWallet.name, simpleWallet.address.pretty(), account.publicKey, account.privateKey, pinCode);
                yield WalletsHelper.add(wallet);
                yield WalletsHelper.setActive(wallet.id);
                this.$router.push('/wallet/creation/new');
            });
        },
        onPassed(pin) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.createWalletWithPin(pin);
            });
        },
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/wallet/WalletCreationName.vue
// module id = 613
// module chunks = 1